// Mock data para One2Tees USA Landing Page
// NOTE: prices already include the +15% bump (applied via scripts/bump_mock_prices_15pct.js).

export const products = [
  {
    id: 1,
    name: "Canvas Premium",
    category: "canvas",
    description: "Impresiones de alta calidad en canvas con bastidor de madera",
    longDescription: "Canvas de artista de 17mil de alta calidad montado en bastidor de madera premium. Impresión de 4 colores (CMYK) con excelente reproducción de color y durabilidad excepcional.",
    basePrice: 42.99,
    image: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/77eth7v7_mounted-canvas.webp",
    sizes: [
      {
        size: "12x12",
        price: 42.99
      },
      {
        size: "12x18",
        price: 56.99
      },
      {
        size: "12x24",
        price: 71.99
      },
      {
        size: "16x20",
        price: 78.99
      },
      {
        size: "16x24",
        price: 92.99
      },
      {
        size: "18x18",
        price: 85.99
      },
      {
        size: "18x24",
        price: 100.99
      },
      {
        size: "20x24",
        price: 114.99
      },
      {
        size: "24x24",
        price: 128.99
      },
      {
        size: "24x36",
        price: 157.99
      },
      {
        size: "36x36",
        price: 229.99
      }
    ],
    specifications: {
      material: "17mil Artist Canvas",
      colorSpec: "4/0 (4 color front)",
      turnaroundOptions: [
        "Next Business Day",
        "4 Business Days"
      ],
      turnaround: "Next Business Day o 4 Business Days",
      printMethod: "High-Resolution Digital Print"
    },
    templates: [
      {
        size: "12x18",
        name: "Template 12x18 Canvas",
        url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/c6zmrtub_12x18-MOUNTEDCANVAS.jpg",
        bleedSize: "16x22"
      },
      {
        size: "18x18",
        name: "Template 18x18 Canvas",
        url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/ianry22i_18x18-MOUNTEDCANVAS.jpg",
        bleedSize: "22x22"
      },
      {
        size: "18x24",
        name: "Template 18x24 Canvas",
        url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/ot8r2nfy_18x24-MOUNTEDCANVAS.jpg",
        bleedSize: "22x28"
      },
      {
        size: "20x24",
        name: "Template 20x24 Canvas",
        url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/ar21r2em_20x24-MOUNTEDCANVAS.jpg",
        bleedSize: "24x28"
      },
      {
        size: "24x12",
        name: "Template 24x12 Canvas",
        url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/xswu7ndk_24x12-MOUNTEDCANVAS.jpg",
        bleedSize: "28x16"
      }
    ],
    filePreparation: {
      resolution: "300dpi mínimo",
      colorMode: "CMYK",
      fileTypes: "PDF, JPG, PNG, TIFF",
      notes: "Las imágenes deben extenderse hasta la línea roja (outer edge). Todo contenido importante debe estar dentro de la línea azul (safety line)."
    },
    features: [
      "Calidad museum-grade",
      "Bastidor de madera premium",
      "Listo para colgar"
    ]
  },
  {
    id: 2,
    name: "Cuadro de Aluminio Sublimado",
    category: "aluminum",
    description: "Impresiones de alta definición mediante dye-sublimation en paneles de aluminio blanco brillante de 0.045\". Diseñado para hacer que las imágenes de alta resolución realmente resalten con una claridad excepcional y colores vibrantes.",
    longDescription: "Impreso mediante dye-sublimation en paneles de aluminio blanco brillante de 0.045\", el proceso de sublimación en aluminio resulta en una claridad de imagen excepcional y vibrancia de color, ofreciendo imágenes de alta definición ideales para fotografía y arte decorativo.",
    basePrice: 56.99,
    image: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/862rujqs_aluminum-dye-sub.webp",
    sizes: [
      {
        size: "8x10",
        price: 56.99
      },
      {
        size: "11x14",
        price: 85.99
      },
      {
        size: "16x20",
        price: 128.99
      },
      {
        size: "20x30",
        price: 186.99
      },
      {
        size: "24x36",
        price: 258.99
      }
    ],
    customSize: {
      enabled: true,
      widthRange: {
        min: 6,
        max: 42,
        unit: "pulgadas"
      },
      heightRange: {
        min: 6,
        max: 36,
        unit: "pulgadas"
      }
    },
    specifications: {
      material: "0.045\" Aluminum - Gloss",
      colorSpec: "4/0 (4 color front)",
      turnaround: "4 Business Days",
      printMethod: "Dye-Sublimation"
    },
    finishOptions: {
      contourCut: {
        options: [
          "No",
          "Yes"
        ],
        prices: {
          No: 0,
          Yes: 32.49
        }
      },
      drillHoleAndHardware: {
        options: [
          "None",
          "3/8\" Drill Hole All 4 Corners",
          "3/8\" Drill hole Center - Top and Bottom",
          "3/8\" Drill hole Top Corners Only",
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole All 4 Corners",
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole Center - Top and Bottom",
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole Top Corners Only"
        ],
        prices: {
          None: 0,
          "3/8\" Drill Hole All 4 Corners": 5.63,
          "3/8\" Drill hole Center - Top and Bottom": 5.63,
          "3/8\" Drill hole Top Corners Only": 5.63,
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole All 4 Corners": 31.24,
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole Center - Top and Bottom": 31.24,
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole Top Corners Only": 31.24
        }
      },
      roundedCorners: {
        options: [
          "No",
          "1\" Round Corners"
        ],
        prices: {
          No: 0,
          "1\" Round Corners": 16.24
        }
      }
    },
    features: [
      "Resistente al agua y duradero",
      "Colores ultra vibrantes de alta definición",
      "Acabado brillante moderno",
      "Ideal para fotografía profesional"
    ],
    uses: [
      "Event Signage",
      "Trade Show Signage",
      "Directional Signage",
      "Informational Signage",
      "Art Museums",
      "Travel & Hospitality"
    ]
  },
  {
    id: 3,
    name: "Señales Acrílicas Personalizadas",
    category: "acrylic",
    description: "Señales acrílicas transparentes con brillo tipo cristal, mucho más ligeras y duraderas que el vidrio. Grosor de 1/4\" con alta resistencia al impacto.",
    longDescription: "Las señales acrílicas personalizadas ofrecen un brillo transparente similar al cristal, en una señal mucho más ligera y duradera que el vidrio. Estas señales de 1/4\" de grosor tienen alta resistencia al impacto, excelente transparencia y durabilidad superior en todas las condiciones climáticas. Proporcionan sofisticación moderna perfecta para cualquier oficina o entorno profesional.",
    basePrice: 64.99,
    image: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/o93i6p37_clear-acrylic-2r.webp",
    sizes: [
      {
        size: "8x10",
        price: 64.99
      },
      {
        size: "12x18",
        price: 92.99
      },
      {
        size: "18x24",
        price: 136.99
      },
      {
        size: "24x36",
        price: 200.99
      },
      {
        size: "30x40",
        price: 272.99
      }
    ],
    customSize: {
      enabled: true,
      widthRange: {
        min: 6,
        max: 36,
        unit: "pulgadas"
      },
      heightRange: {
        min: 6,
        max: 46,
        unit: "pulgadas"
      }
    },
    specifications: {
      material: "1/4\" Clear Acrylic Sign",
      colorSpec: "4/0 (4 color front)",
      colorOptions: [
        "4/0 (4 color front)",
        "4/0 with White Mask"
      ],
      whiteMask: [
        "No",
        "Yes - White Ink Front Only"
      ],
      turnaroundOptions: [
        "Next Business Day",
        "4 Business Days"
      ],
      turnaround: "Next Business Day o 4 Business Days",
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "1\" (0.5 on each side)",
      fileTypes: "PDF, JPG, EPS, TIFF"
    },
    finishOptions: {
      contourCut: {
        options: [
          "No",
          "Yes"
        ],
        prices: {
          No: 0,
          Yes: 25.99
        }
      },
      drillHoleAndHardware: {
        options: [
          "None",
          "3/8\" Drill Hole All 4 Corners",
          "3/8\" Drill hole Center - Top and Bottom",
          "3/8\" Drill hole Top Corners Only",
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole All 4 Corners",
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole Center - Top and Bottom",
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole Top Corners Only"
        ],
        prices: {
          None: 0,
          "3/8\" Drill Hole All 4 Corners": 4.5,
          "3/8\" Drill hole Center - Top and Bottom": 4.5,
          "3/8\" Drill hole Top Corners Only": 4.5,
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole All 4 Corners": 24.99,
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole Center - Top and Bottom": 24.99,
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole Top Corners Only": 24.99
        }
      },
      roundedCorners: {
        options: [
          "No",
          "1\" Round Corners"
        ],
        prices: {
          No: 0,
          "1\" Round Corners": 12.99
        }
      }
    },
    features: [
      "Transparencia tipo cristal",
      "Alta resistencia al impacto",
      "Más ligero y duradero que el vidrio",
      "Perfecto para uso profesional"
    ],
    uses: [
      "Retail",
      "Government/Municipal",
      "Food & Beverage",
      "Entertainment",
      "Healthcare",
      "Travel & Hospitality"
    ]
  },
  {
    id: 4,
    name: "Artist Canvas Banners",
    category: "banner",
    description: "Banners de canvas de artista personalizados, impresos en canvas de alta calidad de 17mil con colores CMYK vibrantes. Perfectos para montaje, enmarcado y eventos elegantes.",
    longDescription: "Capturando la misma apariencia y sensación de un canvas pintado por artistas, los Artist Canvas Banners están impresos en canvas ligero de alta calidad de 17mil con colores CMYK vibrantes. Capaces de envoltura de galería, este producto es perfecto tanto para montaje como para enmarcado y se puede enrollar fácilmente en un tubo cuadrado para envío seguro. Su estilo único los convierte en el sustrato ideal para una variedad de ocasiones, incluyendo eventos elegantes, catas de vino, cenas de recaudación de fondos y más.",
    basePrice: 7.99,
    pricePerSqFt: 7.99,
    image: "https://customer-assets.emergentagent.com/job_e9d2c6bf-88ef-4b47-b9ea-97dc87e98811/artifacts/uahkaxgt_artist-canvas-banners.webp",
    images: [
      "https://customer-assets.emergentagent.com/job_e9d2c6bf-88ef-4b47-b9ea-97dc87e98811/artifacts/uahkaxgt_artist-canvas-banners.webp",
      "https://customer-assets.emergentagent.com/job_e9d2c6bf-88ef-4b47-b9ea-97dc87e98811/artifacts/2znl7bfq_artist-canvas-banners-1r.webp",
      "https://customer-assets.emergentagent.com/job_e9d2c6bf-88ef-4b47-b9ea-97dc87e98811/artifacts/w5qt28x4_artist-canvas-banners-2r.webp"
    ],
    customSize: {
      enabled: true,
      widthRange: {
        min: 12,
        max: 48,
        unit: "pulgadas"
      },
      heightRange: {
        min: 12,
        max: 120,
        unit: "pulgadas"
      }
    },
    specifications: {
      material: "17mil Artist Canvas",
      colorSpec: "4/0 (4 color front)",
      turnaroundOptions: [
        "Next Business Day",
        "4 Business Days"
      ],
      turnaround: "Next Business Day o 4 Business Days",
      printMethod: "High-Resolution Digital Print"
    },
    finishOptions: {
      hems: {
        options: [
          "No Hems",
          "All 4 Sides",
          "Top & Bottom Only"
        ],
        prices: {
          "No Hems": 0,
          "All 4 Sides": 0,
          "Top & Bottom Only": 0
        }
      },
      grommets: {
        options: [
          "No Grommets",
          "Corners Only",
          "Every 2 ft."
        ],
        prices: {
          "No Grommets": 0,
          "Corners Only": 0,
          "Every 2 ft.": 0
        }
      },
      threadColor: {
        options: [
          "None",
          "Black Thread",
          "White Thread"
        ],
        prices: {
          None: 0,
          "Black Thread": 0,
          "White Thread": 0
        }
      },
      polePockets: {
        options: [
          "No Pole Pockets",
          "2 in. Left and Right",
          "4 in. Left and Right",
          "2 in. Top and Bottom",
          "4 in. Top and Bottom"
        ],
        prices: {
          "No Pole Pockets": 0,
          "2 in. Left and Right": 16,
          "4 in. Left and Right": 16,
          "2 in. Top and Bottom": 16,
          "4 in. Top and Bottom": 16
        }
      }
    },
    filePreparation: {
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "No bleed",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    features: [
      "Canvas de artista de 17mil de alta calidad",
      "Colores CMYK vibrantes",
      "Capaz de envoltura de galería",
      "Fácil de enrollar para envío",
      "Ideal para eventos elegantes"
    ],
    uses: [
      "Travel & Hospitality",
      "Theater",
      "Art & Museums",
      "Retail",
      "Food & Beverage",
      "Wine Tastings",
      "Fundraiser Dinners",
      "Upscale Events"
    ]
  },
  {
    id: 5,
    name: "Aluminum Heavy Duty Signs",
    category: "aluminum-hd",
    description: "Señales de aluminio resistente impresas en aluminio de 0.08\" a prueba de óxido para máxima durabilidad en exteriores o interiores.",
    longDescription: "Las señales de Aluminum Heavy Duty están impresas en aluminio resistente de 0.08\" a prueba de óxido para máxima durabilidad en exteriores o interiores. Disponibles en variedad de tamaños con esquinas redondeadas, esquinas rectas o corte de contorno; perforaciones o hardware de standoff opcionales. Usos comunes incluyen señales de estacionamiento, señales de tráfico, notificaciones de fábricas y almacenes, señalización direccional y más.",
    basePrice: 31.99,
    pricePerSqFt: 31.99,
    image: "https://customer-assets.emergentagent.com/job_e9d2c6bf-88ef-4b47-b9ea-97dc87e98811/artifacts/s65f2vjv_aluminum-heavy-duty.webp",
    images: [
      "https://customer-assets.emergentagent.com/job_e9d2c6bf-88ef-4b47-b9ea-97dc87e98811/artifacts/s65f2vjv_aluminum-heavy-duty.webp",
      "https://customer-assets.emergentagent.com/job_e9d2c6bf-88ef-4b47-b9ea-97dc87e98811/artifacts/y39rx30a_649a26eb5403276375654ff7-adt-security-signs28inch-all-aluminum.jpg"
    ],
    customSize: {
      enabled: true,
      widthRange: {
        min: 6,
        max: 36,
        unit: "pulgadas"
      },
      heightRange: {
        min: 6,
        max: 46,
        unit: "pulgadas"
      }
    },
    specifications: {
      material: "Aluminum Heavy Duty .080in. White",
      colorSpec: "4/0 (4 color front)",
      turnaroundOptions: [
        "4 Business Days"
      ],
      turnaround: "4 Business Days",
      printMethod: "High-Resolution Digital Print"
    },
    finishOptions: {
      contourCut: {
        options: [
          "No",
          "Yes"
        ],
        prices: {
          No: 0,
          Yes: 35
        }
      },
      drillHoleAndHardware: {
        options: [
          "None",
          "3/8\" Drill Hole All 4 Corners",
          "3/8\" Drill hole Center - Top and Bottom",
          "3/8\" Drill hole Top Corners Only",
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole All 4 Corners",
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole Center - Top and Bottom",
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole Top Corners Only"
        ],
        prices: {
          None: 0,
          "3/8\" Drill Hole All 4 Corners": 3.5,
          "3/8\" Drill hole Center - Top and Bottom": 3.5,
          "3/8\" Drill hole Top Corners Only": 3.5,
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole All 4 Corners": 32,
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole Center - Top and Bottom": 32,
          "5/8\"X1\" Silver Standoff w/ 3/8\" Drill Hole Top Corners Only": 32
        }
      },
      roundedCorners: {
        options: [
          "No",
          "1\" Round Corners"
        ],
        prices: {
          No: 0,
          "1\" Round Corners": 0
        }
      }
    },
    filePreparation: {
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "1\" (0.5 on each side)",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    features: [
      "Aluminio resistente de 0.08\"",
      "A prueba de óxido",
      "Máxima durabilidad exterior/interior",
      "Opciones de esquinas y corte"
    ],
    uses: [
      "Parking Signs",
      "Traffic Signs",
      "Factory & Warehouse",
      "Directional Signage",
      "Security Signage",
      "Municipal Signs"
    ]
  },
  {
    id: 6,
    name: "Gator Board Signs",
    category: "gator-board",
    description: "Señales de Gator Board duraderas y de larga duración, ideales para señalización comercial y exhibiciones. Más fuertes y duraderas que el foam core.",
    longDescription: "Las señales de Gator Board son duraderas y de larga duración, la opción ideal para señalización comercial y exhibiciones. Este sustrato está compuesto de espuma de poliestireno extruido unida entre dos capas de chapa de fibra de madera e impresa con tintas UV para colores vibrantes y duraderos. Con 3/16\" de grosor, es más fuerte y durable que el foam core pero igual de ligero. Apto para uso interior y exterior, el gator board es excelente para exhibiciones, displays, señalización retail, presentaciones y mucho más.",
    basePrice: 31.99,
    pricePerSqFt: 31.99,
    image: "https://customer-assets.emergentagent.com/job_e9d2c6bf-88ef-4b47-b9ea-97dc87e98811/artifacts/puizyews_gator-board-blackr.webp",
    images: [
      "https://customer-assets.emergentagent.com/job_e9d2c6bf-88ef-4b47-b9ea-97dc87e98811/artifacts/puizyews_gator-board-blackr.webp",
      "https://customer-assets.emergentagent.com/job_e9d2c6bf-88ef-4b47-b9ea-97dc87e98811/artifacts/7cmll1l4_gator-board-signs.webp",
      "https://customer-assets.emergentagent.com/job_e9d2c6bf-88ef-4b47-b9ea-97dc87e98811/artifacts/geo32f6n_gator-board-white.webp"
    ],
    customSize: {
      enabled: true,
      widthRange: {
        min: 6,
        max: 36,
        unit: "pulgadas"
      },
      heightRange: {
        min: 6,
        max: 36,
        unit: "pulgadas"
      }
    },
    specifications: {
      material: "3/16\" Gator Board",
      stockOptions: [
        "3/16\" Black Gator Board",
        "3/16\" White Gator Board"
      ],
      colorSpec: "4/0 (4 color front)",
      colorSpecOptions: [
        "4/0 (4 color front)",
        "4/0 with White Mask",
        "4/4 (4 color both sides)",
        "4/4 with White Mask Both Sides"
      ],
      whiteMaskOptions: [
        "No",
        "Yes - White Ink Front Only"
      ],
      turnaroundOptions: [
        "4 Business Days"
      ],
      turnaround: "4 Business Days",
      printMethod: "UV Ink Print"
    },
    finishOptions: {
      stock: {
        options: [
          "3/16\" Black Gator Board",
          "3/16\" White Gator Board"
        ],
        prices: {
          "3/16\" Black Gator Board": 0,
          "3/16\" White Gator Board": 0
        }
      },
      colorSpec: {
        options: [
          "4/0 (4 color front)",
          "4/0 with White Mask",
          "4/4 (4 color both sides)",
          "4/4 with White Mask Both Sides"
        ],
        prices: {
          "4/0 (4 color front)": 0,
          "4/0 with White Mask": 0,
          "4/4 (4 color both sides)": 0,
          "4/4 with White Mask Both Sides": 0
        }
      },
      whiteMask: {
        options: [
          "No",
          "Yes - White Ink Front Only"
        ],
        prices: {
          No: 0,
          "Yes - White Ink Front Only": 0
        }
      }
    },
    filePreparation: {
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "1\" (0.5 on each side)",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    importantNote: "Para Gator Board Negro: Se requiere archivo de máscara blanca incluso si tu diseño no incluye colores blancos u opacos. Para arte sin elementos blancos, se debe enviar un archivo de máscara vacío. Gator Board Blanco no requiere archivo de máscara.",
    features: [
      "Gator Board de 3/16\" de grosor",
      "Más fuerte que foam core",
      "Ligero y duradero",
      "Tintas UV de larga duración",
      "Uso interior y exterior"
    ],
    uses: [
      "Retail",
      "Food & Beverage",
      "Museums",
      "Educational Institutions",
      "Church",
      "Exhibits & Displays",
      "Presentations"
    ]
  },
  {
    id: 7,
    name: "3mm Custom PVC",
    category: "pvc",
    description: "Señales de PVC personalizadas de 3mm, ideales para uso interior y exterior. Ligeras, duraderas, resistentes al clima y con acabado mate de bajo brillo.",
    longDescription: "Las señales de 3mm Custom PVC son una excelente opción para cualquier necesidad de señalización interior o exterior. Son ligeras, duraderas, resistentes al clima e impresas en plástico rígido liso de color blanco brillante. Tienen un aspecto mate de bajo brillo y son resistentes a abolladuras y rayones. Proporcionan excelente calidad de impresión y mantienen su color en diversas condiciones de iluminación y clima, siendo ideales para señalización exterior.",
    basePrice: 9.99,
    pricePerSqFt: 9.99,
    image: "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/zis1nehp_pvc-signs.webp",
    images: [
      "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/zis1nehp_pvc-signs.webp",
      "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/w495dqyu_pvc-signs-zoomed.webp",
      "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/ozw7zldu_zoo-pvc-signs-b_w.webp"
    ],
    sizes: [
      {
        size: "18x12",
        price: 14.99
      },
      {
        size: "18x24",
        price: 28.99
      },
      {
        size: "22x28",
        price: 41.99
      },
      {
        size: "24x12",
        price: 19.99
      },
      {
        size: "24x18",
        price: 28.99
      },
      {
        size: "24x24",
        price: 38.99
      },
      {
        size: "24x36",
        price: 58.99
      }
    ],
    customSize: {
      enabled: true,
      widthRange: {
        min: 6,
        max: 36,
        unit: "pulgadas"
      },
      heightRange: {
        min: 6,
        max: 46,
        unit: "pulgadas"
      }
    },
    specifications: {
      material: "3mm PVC (⅛\" thick)",
      colorSpec: "4/0 (4 color front)",
      colorSpecOptions: [
        "4/0 (4 color front)",
        "4/4 (4 color both sides)"
      ],
      turnaroundOptions: [
        "Next Business Day",
        "4 Business Days"
      ],
      turnaround: "Next Business Day o 4 Business Days",
      printMethod: "High-Resolution Digital Print",
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "1\" (0.5 on each side)",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    finishOptions: {
      colorSpec: {
        options: [
          "4/0 (4 color front)",
          "4/4 (4 color both sides)"
        ],
        prices: {
          "4/0 (4 color front)": 0,
          "4/4 (4 color both sides)": 0
        }
      },
      grommets: {
        options: [
          "No Grommets",
          "All 4 Corners",
          "Top Corners Only"
        ],
        prices: {
          "No Grommets": 0,
          "All 4 Corners": 5,
          "Top Corners Only": 3
        }
      },
      roundedCorners: {
        options: [
          "No",
          "1\" Round Corners"
        ],
        prices: {
          No: 0,
          "1\" Round Corners": 4
        }
      }
    },
    filePreparation: {
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "1\" (0.5 on each side)",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    features: [
      "PVC de 3mm (⅛\") de grosor",
      "Ligero y duradero",
      "Resistente al clima",
      "Acabado mate de bajo brillo",
      "Resistente a abolladuras y rayones",
      "Uso interior y exterior"
    ],
    uses: [
      "Event Signage",
      "Trade Show Signage",
      "Directional Signage",
      "Informational Signage",
      "Real Estate Signage",
      "Wayfinding",
      "Menu Boards",
      "POP (Point of Purchase)"
    ]
  },
  {
    id: 8,
    name: "Foam Core Signs",
    category: "foam-core",
    description: "Señales de Foam Core de 3/16\" extremadamente ligeras, ideales para presentaciones en caballete, señalización interior, posters y displays. Compuesto de espuma de poliestireno extruido con papel blanco recubierto de arcilla.",
    longDescription: "Las señales de Foam Core de 3/16\" de 4over se montan típicamente en un caballete para presentaciones, pero también pueden usarse para cualquier señal interior, poster o display. Extremadamente ligero, el Foam Core está compuesto de espuma de poliestireno extruido con revestimientos de papel blanco recubierto de arcilla. Las señales de Foam Core son ideales para un solo uso, pero pueden durar más con el cuidado adecuado. Este producto NO es resistente al agua.",
    basePrice: 6.99,
    pricePerSqFt: 6.99,
    image: "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/zjhs9dt3_foam-core-signs.webp",
    images: [
      "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/zjhs9dt3_foam-core-signs.webp",
      "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/vax176vy_71PgUlYAZbL._AC_SX679_.jpg"
    ],
    sizes: [
      {
        size: "18x12",
        price: 9.99
      },
      {
        size: "18x24",
        price: 20.99
      },
      {
        size: "22x28",
        price: 29.99
      },
      {
        size: "24x12",
        price: 13.99
      },
      {
        size: "24x18",
        price: 20.99
      },
      {
        size: "24x24",
        price: 27.99
      },
      {
        size: "24x36",
        price: 40.99
      }
    ],
    customSize: {
      enabled: true,
      widthRange: {
        min: 6,
        max: 36,
        unit: "pulgadas"
      },
      heightRange: {
        min: 6,
        max: 46,
        unit: "pulgadas"
      }
    },
    specifications: {
      material: "3/16\" Foam Core",
      colorSpec: "4/0 (4 color front)",
      colorSpecOptions: [
        "4/0 (4 color front)",
        "4/4 (4 color both sides)"
      ],
      turnaroundOptions: [
        "Next Business Day",
        "4 Business Days"
      ],
      turnaround: "Next Business Day o 4 Business Days",
      printMethod: "High-Resolution Digital Print",
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "1\" (0.5 on each side)",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    finishOptions: {
      colorSpec: {
        options: [
          "4/0 (4 color front)",
          "4/4 (4 color both sides)"
        ],
        prices: {
          "4/0 (4 color front)": 6,
          "4/4 (4 color both sides)": 9
        },
        isPricePerSqFt: true
      }
    },
    filePreparation: {
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "1\" (0.5 on each side)",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    importantNote: "Este producto NO es resistente al agua. Ideal para uso interior únicamente. Puede durar más tiempo con el cuidado adecuado.",
    features: [
      "Foam Core de 3/16\" de grosor",
      "Extremadamente ligero",
      "Papel blanco recubierto de arcilla",
      "Ideal para presentaciones",
      "Solo uso interior"
    ],
    uses: [
      "Presentations",
      "Easel Displays",
      "Interior Signs",
      "Posters",
      "Trade Shows",
      "Events",
      "Educational Displays",
      "Retail Signage"
    ]
  },
  {
    id: 9,
    name: "4mm Coroplast Signs",
    category: "coroplast",
    description: "Señales de Coroplast de 4mm, la opción económica perfecta para cualquier negocio. Ideales para señalización de jardín, política, bienes raíces y más. Versátiles para interiores y duraderas para exteriores.",
    longDescription: "Las señales de 4mm Coroplast son la opción económica perfecta para cualquier negocio. Con señalización de coroplast de 4mm, sus clientes pueden crear señales de jardín personalizadas para todas sus necesidades promocionales, direccionales y políticas. Impresas a todo color en plástico corrugado rígido con ojales opcionales, son lo suficientemente versátiles para colocarse en interiores y lo suficientemente duraderas con tintas curadas UV y durabilidad impermeable para colocarse en exteriores con estacas. A temperaturas regulares, los aceites, solventes y agua no tienen efecto en el coroplast.",
    basePrice: 3.99,
    pricePerSqFt: 3.99,
    hasVolumeDiscounts: true,
    volumePricing: {
      "4/4 (4 color both sides)": {
        "1": 3.99,
        "6": 2.99,
        "26": 2.99,
        "51": 2.99,
        "76": 2.99
      },
      "4/0 (4 color front)": {
        "1": 3.99,
        "6": 2.99,
        "26": 2.99,
        "51": 2.99,
        "76": 2.99
      }
    },
    image: "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/ahkwrac9_coroplast-signs.webp",
    images: [
      "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/ahkwrac9_coroplast-signs.webp",
      "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/ziih320p_coroplast-b_w.webp",
      "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/mjqfot9a_coroplast_zoomed.webp",
      "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/4gfr404i_61iTyhlVoZL._SX522_.jpg"
    ],
    customSize: {
      enabled: true,
      widthRange: {
        min: 6,
        max: 36,
        unit: "pulgadas"
      },
      heightRange: {
        min: 6,
        max: 46,
        unit: "pulgadas"
      }
    },
    specifications: {
      material: "4mm White Coroplast",
      colorSpec: "4/4 (4 color both sides)",
      colorSpecOptions: [
        "4/0 (4 color front)",
        "4/4 (4 color both sides)"
      ],
      fluteDirections: [
        "Horizontal",
        "Vertical"
      ],
      turnaroundOptions: [
        "Same Business Day",
        "Next Day Express",
        "Next Business Day",
        "4 Business Days",
        "7 Business Days"
      ],
      turnaround: "Same Business Day to 7 Business Days",
      printMethod: "UV-Cured Digital Print",
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "1\" (0.5 on each side)",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    finishOptions: {
      colorSpec: {
        options: [
          "4/0 (4 color front)",
          "4/4 (4 color both sides)"
        ],
        discount: {
          "4/0 (4 color front)": 0.95,
          "4/4 (4 color both sides)": 1
        }
      },
      fluteDirection: {
        options: [
          "Horizontal",
          "Vertical"
        ],
        prices: {
          Horizontal: 0,
          Vertical: 0
        },
        note: "Para H-Stakes, use orientación vertical"
      },
      grommets: {
        options: [
          "None",
          "All 4 Corners",
          "Top Corners Only"
        ],
        prices: {
          None: 0,
          "All 4 Corners": 0.45,
          "Top Corners Only": 0.45
        }
      },
      hStakes: {
        options: [
          "No",
          "Yes"
        ],
        prices: {
          No: 0,
          Yes: 1.5
        }
      },
      contourCut: {
        options: [
          "No",
          "Yes"
        ],
        prices: {
          No: 0,
          Yes: 0
        },
        isPercentage: true,
        percentageIncrease: 10
      }
    },
    filePreparation: {
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "1\" (0.5 on each side)",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    importantNotes: [
      "Al ordenar H-Stakes, coloque su pedido con el ancho mayor que la altura y ordene con acanalado vertical.",
      "La estructura acanalada corrugada resulta en un efecto lineal muy sutil (líneas tenues) en la superficie del producto.",
      "Los acanalados pueden ser horizontales o verticales pero solo son compatibles con H-Stakes en orientación vertical."
    ],
    features: [
      "Coroplast de 4mm de grosor",
      "Resistente al agua y UV",
      "Ideal para interiores y exteriores",
      "Tintas curadas UV",
      "Compatible con H-Stakes"
    ],
    uses: [
      "Political Signs",
      "Yard Signs",
      "Real Estate",
      "Healthcare",
      "Educational Institutions",
      "Retail"
    ]
  },
  {
    id: 10,
    name: "Sidewalk Signs (A-Frame)",
    category: "sidewalk-signs",
    description: "Señales de acera portátiles perfectas para promoción exterior en todo clima. Marcos de plástico duradero con insertos de Coroplast 4mm intercambiables. Disponibles en 3 tamaños populares.",
    longDescription: "Las Sidewalk Signs de 4over son la señalización promocional portátil perfecta para uso exterior en todo clima. Fabricadas con plástico duradero, en 3 tamaños únicos y populares, los marcos se combinan con insertos de Coroplast 4mm intercambiables. Ofrecemos el grande Signicade® Deluxe (insertos de 24\"W x 36\"H); mediano Signicade® MDX (insertos de 18\"W x 24\"H) o pequeño Quik Sign® (insertos de Coroplast 24\"W x 18\"H).",
    basePrice: 183.99,
    image: "https://customer-assets.emergentagent.com/job_388b0df2-b5ee-4956-bc68-28d7ba263f07/artifacts/m3y4ron6_PR_1245-01_SideWalkSign.png",
    images: [
      "https://customer-assets.emergentagent.com/job_388b0df2-b5ee-4956-bc68-28d7ba263f07/artifacts/m3y4ron6_PR_1245-01_SideWalkSign.png",
      "https://customer-assets.emergentagent.com/job_388b0df2-b5ee-4956-bc68-28d7ba263f07/artifacts/q05hj8si_sidewalk-signs_1.webp"
    ],
    sizes: [
      {
        size: "24x18",
        price: 183.99,
        hardware: "Signicade Quik Sign Plastic Frame - White"
      },
      {
        size: "18x24",
        price: 204.99,
        hardware: "Signicade MDX Plastic Frame - White"
      },
      {
        size: "24x36",
        price: 269.99,
        hardware: "Signicade Deluxe Plastic Frame - White"
      }
    ],
    specifications: {
      material: "4mm White Coroplast",
      colorSpec: "4/0 (4 color front)",
      colorSpecOptions: [
        "4/0 (4 color front)",
        "4/4 (4 color both sides)"
      ],
      fluteDirections: [
        "Vertical",
        "Horizontal"
      ],
      turnaroundOptions: [
        "4 Business Days"
      ],
      turnaround: "4 Business Days",
      printMethod: "UV-Cured Digital Print",
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "1\" (0.5 on each side)",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    finishOptions: {
      colorSpec: {
        options: [
          "4/0 (4 color front)",
          "4/4 (4 color both sides)"
        ],
        prices: {
          "4/0 (4 color front)": 0,
          "4/4 (4 color both sides)": 0
        }
      },
      fluteDirection: {
        options: [
          "Vertical",
          "Horizontal"
        ],
        prices: {
          Vertical: 0,
          Horizontal: 0
        }
      }
    },
    filePreparation: {
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "1\" (0.5 on each side)",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    hardwareInfo: {
      "24x18": {
        name: "Signicade Quik Sign",
        description: "Marco de plástico blanco compacto, perfecto para espacios pequeños"
      },
      "18x24": {
        name: "Signicade MDX",
        description: "Marco de plástico blanco mediano, ideal para mayor visibilidad"
      },
      "24x36": {
        name: "Signicade Deluxe",
        description: "Marco de plástico blanco grande, máximo impacto visual"
      }
    },
    features: [
      "Marco de plástico duradero incluido",
      "Insertos de Coroplast 4mm intercambiables",
      "Resistente a todo clima",
      "Portátil y fácil de transportar",
      "Configuración tipo A-Frame estable"
    ],
    uses: [
      "Retail",
      "Restaurants",
      "Real Estate",
      "Events",
      "Trade Shows",
      "Sidewalk Advertising",
      "Grand Openings",
      "Sales & Promotions"
    ]
  },
  {
    id: 11,
    name: "Scrim Vinyl Banners",
    category: "scrim-vinyl",
    description: "Promote, advertise, or make announcements with durable Scrim Vinyl Banners. Printed on 13oz scrim vinyl with UV-cured inks, waterproof and weather-resistant.",
    longDescription: "Scrim vinyl banners are designed to stand out at any indoor or outdoor event. Printed on 13oz scrim vinyl with UV-cured inks, these banners are waterproof, durable, and will maintain their vibrance — rain or shine. Easily customizable, scrim vinyl banners are available in flexible sizes, up to 16' in one direction and 150' in the other.",
    basePrice: 5.99,
    pricePerSqFt: 5.99,
    image: "https://customer-assets.emergentagent.com/job_44cf03cf-7713-4c75-b532-ae8980a870ea/artifacts/psuv4ax4_BANNERS.webp",
    images: [
      "https://customer-assets.emergentagent.com/job_44cf03cf-7713-4c75-b532-ae8980a870ea/artifacts/psuv4ax4_BANNERS.webp",
      "https://customer-assets.emergentagent.com/job_44cf03cf-7713-4c75-b532-ae8980a870ea/artifacts/loyi2mja_13oz_banner_option_velcro_1.webp",
      "https://customer-assets.emergentagent.com/job_44cf03cf-7713-4c75-b532-ae8980a870ea/artifacts/s3dwit7m_scrim-vinyl-banner_b_w.webp",
      "https://customer-assets.emergentagent.com/job_44cf03cf-7713-4c75-b532-ae8980a870ea/artifacts/8skklmzn_scrim-vinyl-banner_zoomed.webp"
    ],
    customSize: {
      widthRange: {
        min: 12,
        max: 192
      },
      heightRange: {
        min: 12,
        max: 1800
      }
    },
    specifications: {
      material: "13oz Scrim Vinyl - Outdoor",
      colorSpec: "4/0 (4 color front)",
      turnaroundOptions: [
        "4 Business Days"
      ],
      turnaround: "4 Business Days",
      printMethod: "UV-Cured Digital Print",
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "No bleed",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    finishOptions: {
      grommets: {
        options: [
          "No Grommets",
          "Corners Only",
          "Every 1 ft.",
          "Every 2 ft."
        ],
        prices: {
          "No Grommets": 0,
          "Corners Only": 5,
          "Every 1 ft.": 1.5,
          "Every 2 ft.": 1.5
        }
      },
      hems: {
        options: [
          "No Hems",
          "All 4 Sides",
          "Top & Bottom Only"
        ],
        prices: {
          "No Hems": 0,
          "All 4 Sides": 10,
          "Top & Bottom Only": 5
        }
      },
      polePockets: {
        options: [
          "No Pole Pockets",
          "2 in. Left and Right",
          "4 in. Left and Right",
          "2 in. Top and Bottom",
          "4 in. Top and Bottom"
        ],
        prices: {
          "No Pole Pockets": 0,
          "2 in. Left and Right": 2,
          "4 in. Left and Right": 2,
          "2 in. Top and Bottom": 2,
          "4 in. Top and Bottom": 2
        }
      },
      dRings: {
        options: [
          "No D-Rings",
          "D-Rings and Webbing",
          "D-Rings All 4 Corners",
          "D-Rings Top Corners Only"
        ],
        prices: {
          "No D-Rings": 0,
          "D-Rings and Webbing": 1,
          "D-Rings All 4 Corners": 4,
          "D-Rings Top Corners Only": 2
        }
      },
      velcro: {
        options: [
          "No Velcro",
          "Velcro - Hems All 4 Sides",
          "Velcro - Hems Top & Bottom Only"
        ],
        prices: {
          "No Velcro": 0,
          "Velcro - Hems All 4 Sides": 35,
          "Velcro - Hems Top & Bottom Only": 30
        }
      },
      rope: {
        options: [
          "No Rope",
          "Sewn Rope and Hems - Top and Bottom",
          "Sewn Rope and Hem - Top Only"
        ],
        prices: {
          "No Rope": 0,
          "Sewn Rope and Hems - Top and Bottom": 0,
          "Sewn Rope and Hem - Top Only": 0
        }
      }
    },
    filePreparation: {
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "No bleed",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    importantNotes: [
      "Banners that exceed 8 feet (96 inches) in length will be folded for shipping due to UPS restrictions.",
      "To remove wrinkles or creases, gently heat the non-printed surface with a hairdryer or steam iron at low temperature. DO NOT USE A HOT IRON.",
      "#2 brass grommets with ⅜\" outside diameter are placed in all four corners and every 24 inches as evenly distributed as possible.",
      "Banner hems are heat welded which creates a hem far stronger than standard stitched hem."
    ],
    features: [
      "13oz scrim vinyl material",
      "Waterproof and weather-resistant",
      "UV-cured inks for vibrant colors",
      "Flexible sizes up to 16' x 150'",
      "Indoor and outdoor use",
      "Heat-welded hems available"
    ],
    uses: [
      "Billboards",
      "Building Wraps",
      "Parades",
      "Grand Openings",
      "Sales Events",
      "Festivals",
      "Sporting Events",
      "Health Fairs",
      "Fundraisers",
      "Trade Shows"
    ]
  },
  {
    id: 12,
    name: "Mesh Banners",
    category: "mesh-banner",
    description: "Weather-resistant mesh banners with 37% airflow. Perfect for outdoor signage in high-wind areas including sporting events, festivals, and building wraps.",
    longDescription: "Mesh banners are the perfect all-weather outdoor signage solution. Produced on 8oz mesh vinyl to allow 37% airflow through, these banners are the ideal choice for outdoor signage in a wide range of settings, including sporting events, outdoor parties, festivals, and more. Their durability allows them to withstand harsh weather conditions, including wind, and are typically hung on fences, on the sides of buildings, between posts, or independently with poles. Please note: because the banner is comprised of perforated/mesh material, it will appear slightly more transparent than traditional vinyl banners.",
    basePrice: 5.99,
    pricePerSqFt: 5.99,
    image: "https://customer-assets.emergentagent.com/job_24e755e1-70ea-4e28-aba4-b43c9ab71ff4/artifacts/eff3zczq_mesh-banner.webp",
    images: [
      "https://customer-assets.emergentagent.com/job_24e755e1-70ea-4e28-aba4-b43c9ab71ff4/artifacts/eff3zczq_mesh-banner.webp",
      "https://customer-assets.emergentagent.com/job_24e755e1-70ea-4e28-aba4-b43c9ab71ff4/artifacts/njxe8s9u_mesh-banner._b_w.webp",
      "https://customer-assets.emergentagent.com/job_24e755e1-70ea-4e28-aba4-b43c9ab71ff4/artifacts/avjzgw8j_mesh-banner_zoomed.webp"
    ],
    customSize: {
      enabled: true,
      widthRange: {
        min: 12,
        max: 120,
        unit: "inches"
      },
      heightRange: {
        min: 12,
        max: 360,
        unit: "inches"
      }
    },
    specifications: {
      material: "8oz Mesh Banner - Outdoor",
      colorSpec: "4/0 (4 color front)",
      turnaroundOptions: [
        "4 Business Days"
      ],
      turnaround: "4 Business Days",
      printMethod: "UV-Cured Digital Print",
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "No bleed",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    finishOptions: {
      hems: {
        options: [
          "No Hems",
          "All 4 Sides",
          "Top & Bottom Only"
        ],
        prices: {
          "No Hems": 0,
          "All 4 Sides": 0,
          "Top & Bottom Only": 0
        }
      },
      grommets: {
        options: [
          "No Grommets",
          "Corners Only",
          "Every 2 ft."
        ],
        prices: {
          "No Grommets": 0,
          "Corners Only": 4,
          "Every 2 ft.": 10
        }
      },
      polePockets: {
        options: [
          "None",
          "4 in. Left and Right",
          "2 in. Top and Bottom",
          "4 in. Top and Bottom"
        ],
        prices: {
          None: 0,
          "4 in. Left and Right": 5,
          "2 in. Top and Bottom": 2,
          "4 in. Top and Bottom": 5
        }
      }
    },
    filePreparation: {
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "No bleed",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    importantNotes: [
      "Mesh banners allow 37% airflow, making them ideal for windy conditions.",
      "Due to the perforated material, artwork will have a more subtle/muted appearance than traditional vinyl banners.",
      "Single-sided printing only (4/0).",
      "Water resistant and suitable for indoor and outdoor use."
    ],
    features: [
      "8oz mesh vinyl material",
      "37% airflow through material",
      "Weather-resistant and durable",
      "Ideal for high-wind locations",
      "Indoor and outdoor use",
      "Perfect for fence and building wraps"
    ],
    uses: [
      "Sports Events",
      "Festivals",
      "Retail",
      "Political Campaigns",
      "Government/Municipal",
      "Promotions",
      "Advertising",
      "Street Signage",
      "Building Wraps",
      "Fence Wraps"
    ],
    faqs: [
      {
        question: "Are there additional finishing options for mesh banners?",
        answer: "Mesh banners can be finished with pole pockets, grommets, and hems."
      },
      {
        question: "Can you see through mesh banners?",
        answer: "Yes, mesh banners can be seen through due to the perforated material."
      },
      {
        question: "What is the ideal use for mesh banners?",
        answer: "Mesh banners are economical, lightweight, and allow 37% air flow through making them ideal for building, stadium, and fence wraps."
      },
      {
        question: "Can you print on both sides of the mesh banner?",
        answer: "Currently only single-sided printing is available on mesh banners."
      },
      {
        question: "Are mesh banners water resistant?",
        answer: "Yes, mesh banners are water resistant products that are great for outdoor and indoor use."
      }
    ]
  },
  {
    id: 13,
    name: "Deluxe Retractable Banner Stand",
    category: "banner-stands",
    description: "Banner stand retráctil de lujo con base cromada pesada. Incluye estuche de transporte. Ideal para eventos, ferias y exhibiciones.",
    longDescription: "Banner stand retráctil de lujo de un solo lado con base más grande y pesada con acentos cromados para destacar en cualquier entorno. El banner pull-up a todo color impreso en vinilo interior de 10mil ofrece un sustrato grueso y duradero. Completamente plegable con estuche de transporte incluido. Peso: 14 lbs.",
    basePrice: 218.99,
    image: "https://customer-assets.emergentagent.com/job_5ce9b342-087e-477a-8000-70065ac8ec40/artifacts/jgx0qchm_deluxe-single-sided-retractable-banner-stands.webp",
    galleryImages: [
      "https://customer-assets.emergentagent.com/job_5ce9b342-087e-477a-8000-70065ac8ec40/artifacts/jgx0qchm_deluxe-single-sided-retractable-banner-stands.webp",
      "https://customer-assets.emergentagent.com/job_5ce9b342-087e-477a-8000-70065ac8ec40/artifacts/uyu8kqie_delux-retractable-b_w.webp",
      "https://customer-assets.emergentagent.com/job_5ce9b342-087e-477a-8000-70065ac8ec40/artifacts/r5kte1uj_delux-retractable-zoomed.webp"
    ],
    sizes: [
      {
        size: "33x80",
        price: 218.99
      }
    ],
    specifications: {
      material: "10mil Polypropylene - Indoor",
      colorSpec: "4/0 (4 color front)",
      hardware: "Single-Sided Deluxe Retractable Banner Stand",
      turnaroundOptions: [
        "4 Business Days"
      ],
      turnaround: "4 Business Days",
      printMethod: "Full-Color Digital Print",
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "1 inch (0.5 on each side)",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF",
      weight: "14 lbs"
    },
    finishOptions: null,
    filePreparation: {
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "1 inch (0.5 on each side)",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    importantNotes: [
      "Banner viene pre-instalado en el stand retráctil.",
      "Incluye estuche de transporte para fácil portabilidad.",
      "Base cromada deluxe más grande y pesada que el modelo estándar.",
      "Solo impresión de un lado disponible."
    ],
    features: [
      "Base cromada deluxe",
      "Vinilo indoor de 10mil",
      "Estuche de transporte incluido",
      "Completamente plegable",
      "Peso: 14 lbs",
      "Tamaño: 33\" x 80\""
    ],
    uses: [
      "Trade Shows",
      "Fitness Clubs",
      "Fundraisers",
      "Travel & Hospitality",
      "Retail",
      "Restaurants",
      "POP Display",
      "Seasonal Signage",
      "Product Launches",
      "Open Houses"
    ],
    faqs: [
      {
        question: "Can the banner on the retractable banner stand be replaced?",
        answer: "While possible, it can be a difficult task to switch out the banner. We recommend purchasing a new retractable banner stand to avoid damaging your print or stand."
      },
      {
        question: "What is the difference between the deluxe and standard retractable banner stand?",
        answer: "Deluxe banner stands are a more stylish alternative with a bigger, heavier base and chrome accents to make them stand out."
      },
      {
        question: "How is the retractable banner transported between locations?",
        answer: "Each banner stand comes with a convenient carrying case making it easy to transport."
      },
      {
        question: "What are retractable banner stands used for?",
        answer: "Retractable banner stands are great for tradeshows, promoting sales and offers, events, and so much more."
      }
    ]
  },
  {
    id: 14,
    name: "Car Door Magnets",
    category: "magnets",
    description: "Imanes magnéticos para puertas de carros. Valla publicitaria móvil para maximizar la visibilidad de tu marca.",
    longDescription: "Ayuda a tus clientes a crear su propia valla publicitaria móvil para maximizar el conocimiento de marca dondequiera que vayan. Los imanes para puertas de carro son ideales para vehículos pero también pueden usarse en otras superficies metálicas como señales temporales en sitios de construcción o cualquier ambiente de trabajo cambiante.",
    pricePerSqFt: 57.99,
    image: "https://customer-assets.emergentagent.com/job_5ce9b342-087e-477a-8000-70065ac8ec40/artifacts/z97nqm3m_car%20magnet.png",
    galleryImages: [
      "https://customer-assets.emergentagent.com/job_5ce9b342-087e-477a-8000-70065ac8ec40/artifacts/z97nqm3m_car%20magnet.png",
      "https://customer-assets.emergentagent.com/job_5ce9b342-087e-477a-8000-70065ac8ec40/artifacts/d8rteth5_car-door-magnets_1_1.webp"
    ],
    sizes: [
      {
        size: "9x9",
        price: 31.99
      },
      {
        size: "9x12",
        price: 42.99
      },
      {
        size: "9x18",
        price: 64.99
      },
      {
        size: "9x24",
        price: 85.99
      },
      {
        size: "9x30",
        price: 107.99
      },
      {
        size: "9x36",
        price: 128.99
      },
      {
        size: "12x12",
        price: 57.99
      },
      {
        size: "12x18",
        price: 85.99
      },
      {
        size: "18x24",
        price: 172.99
      },
      {
        size: "24x12",
        price: 114.99
      },
      {
        size: "24x18",
        price: 172.99
      },
      {
        size: "24x24",
        price: 229.99
      },
      {
        size: "24x30",
        price: 287.99
      },
      {
        size: "24x36",
        price: 344.99
      }
    ],
    specifications: {
      material: "30mil Magnet",
      colorSpec: "4/0 (4 color front)",
      coating: "UV Coating Front Only",
      turnaroundOptions: [
        "Next Business Day",
        "4 Business Days"
      ],
      turnaround: "4 Business Days",
      printMethod: "Full-Color Digital Print",
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "No bleed",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    finishOptions: {
      roundCorners: [
        "Yes",
        "No"
      ]
    },
    filePreparation: {
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "No bleed",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    importantNotes: [
      "Ideales para vehículos y superficies metálicas.",
      "Material magnético de 30mil de alta durabilidad.",
      "Recubrimiento UV en el frente para mayor protección.",
      "Disponible con o sin esquinas redondeadas."
    ],
    features: [
      "Magnético 30mil heavy-duty",
      "Acabado brillante con UV",
      "Esquinas redondeadas disponibles",
      "Ideal para vehículos",
      "Fácil de aplicar y remover",
      "Resistente a la intemperie"
    ],
    uses: [
      "Construction",
      "Retail",
      "Real Estate",
      "Non-Profits",
      "Contractors",
      "Delivery Services",
      "Food Trucks",
      "Mobile Businesses"
    ],
    faqs: [
      {
        question: "Can car door magnets damage my vehicle's paint?",
        answer: "No, when properly used and maintained, car door magnets will not damage your vehicle's paint. Always clean both surfaces before applying and remove periodically to prevent moisture buildup."
      },
      {
        question: "How long do car door magnets last?",
        answer: "With proper care, car door magnets can last several years. The UV coating protects against fading from sun exposure."
      },
      {
        question: "Can I use these magnets in rain?",
        answer: "Yes, the magnets are weather-resistant. However, we recommend removing them and drying both surfaces after heavy rain to prevent moisture buildup."
      }
    ]
  },
  {
    id: 15,
    name: "Standard Business Cards",
    category: "business-cards",
    description: "Tarjetas de presentación estándar impresas en stock superior. Expande el conocimiento de tu marca con las mejores tarjetas del mercado.",
    longDescription: "Alcanza nuevos segmentos de mercado, expande el conocimiento de marca y mantén contactos esenciales con nuestras tarjetas de presentación estándar de primera calidad. Impresas en stock superior con recubrimiento UV opcional. Disponibles en una amplia variedad de especificaciones, tamaños y cantidades.",
    basePrice: 18.99,
    image: "https://customer-assets.emergentagent.com/job_5ce9b342-087e-477a-8000-70065ac8ec40/artifacts/3mudf9ti_business-card-standard1.webp",
    galleryImages: [
      "https://customer-assets.emergentagent.com/job_5ce9b342-087e-477a-8000-70065ac8ec40/artifacts/3mudf9ti_business-card-standard1.webp",
      "https://customer-assets.emergentagent.com/job_5ce9b342-087e-477a-8000-70065ac8ec40/artifacts/hirojs5t_1-4-ROUNDCORNER-3.5X2-SMART-V2.jpg",
      "https://customer-assets.emergentagent.com/job_5ce9b342-087e-477a-8000-70065ac8ec40/artifacts/r0an3m2s_3.5X2.jpg"
    ],
    requiresDualUpload: true,
    quantityPricing: {
      "2x3.5": {
        "500": 92.99,
        "1000": 110.99,
        "2500": 216.99,
        "5000": 310.99,
        "10000": 561.99
      }
    },
    sizes: [
      {
        size: "1.5x3.5",
        label: "1.5\" x 3.5\""
      },
      {
        size: "1.75x3.5",
        label: "1.75\" x 3.5\""
      },
      {
        size: "2x2",
        label: "2\" x 2\""
      },
      {
        size: "2x3",
        label: "2\" x 3\""
      },
      {
        size: "2x3.5",
        label: "2\" x 3.5\" (US Standard)"
      },
      {
        size: "2.125x3.375",
        label: "2.125\" x 3.375\" (EU Standard)"
      },
      {
        size: "2.5x2.5",
        label: "2.5\" x 2.5\""
      }
    ],
    specifications: {
      turnaroundOptions: [
        "4 Business Days",
        "7 Business Days"
      ],
      turnaround: "4 Business Days",
      printMethod: "Full-Color Digital/Offset Print",
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "0.125 inch (0.0625 on each side)",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    finishOptions: {
      shape: [
        "Rectangle",
        "Rounded 4 Corners",
        "Rounded 2 Corners",
        "Square",
        "Round"
      ],
      cornerRadius: [
        "1/8 inch",
        "1/4 inch"
      ],
      stock: [
        "14PT C2S",
        "14PT Uncoated",
        "16PT C2S",
        "18PT C1S",
        "100LB Gloss Cover"
      ],
      colorSpec: [
        "4/0 (front only)",
        "4/1",
        "4/4 (both sides)"
      ],
      coating: [
        "No Coating",
        "UV Coating Front Only",
        "UV on 4-color side",
        "Matte",
        "Aqueous Coating",
        "Satin Aqueous"
      ],
      spotUV: [
        {
          label: "No Spot UV",
          price: 0
        },
        {
          label: "Spot UV Front",
          price: 62.99
        },
        {
          label: "Spot UV Both Sides",
          price: 74.99
        },
        {
          label: "Spot UV Back + Full UV Front",
          price: 74.99
        }
      ]
    },
    filePreparation: {
      resolution: "300dpi",
      colorMode: "CMYK",
      bleed: "0.125 inch (0.0625 on each side)",
      fileTypes: "PDF (recommended), JPG, EPS, TIFF"
    },
    importantNotes: [
      "Se requiere archivo para el frente y reverso de la tarjeta.",
      "Tamaño estándar US: 2\" x 3.5\"",
      "Spot UV disponible con costo adicional.",
      "Disponible en múltiples tipos de papel y acabados."
    ],
    features: [
      "Impresión a todo color",
      "Múltiples opciones de papel",
      "Spot UV disponible",
      "Esquinas redondeadas opcionales",
      "Entrega rápida 4-7 días",
      "Stock premium 14-18PT"
    ],
    uses: [
      "Bankers",
      "Retail",
      "Real Estate",
      "Education",
      "Non-Profits",
      "Contractors",
      "Healthcare",
      "Legal Services"
    ],
    faqs: [
      {
        question: "What is the standard business card size?",
        answer: "The US standard business card size is 2\" x 3.5\". We also offer EU standard (2.125\" x 3.375\") and other sizes."
      },
      {
        question: "What is Spot UV coating?",
        answer: "Spot UV is a glossy, raised coating applied to specific areas of your card to highlight logos, text, or graphics. It creates a premium look and feel."
      },
      {
        question: "What paper stock should I choose?",
        answer: "14PT C2S is our most popular option - it's sturdy and professional. 16PT and 18PT offer even more thickness. Uncoated stock is great for a classic, writable finish."
      },
      {
        question: "Do I need to upload files for both sides?",
        answer: "Yes, please upload separate files for the front and back of your business card."
      }
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "María González",
    location: "Miami, FL",
    rating: 5,
    comment: "La calidad de los canvas es increíble. Mis fotos familiares lucen espectaculares en la sala.",
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Maria"
  },
  {
    id: 2,
    name: "Carlos Rodríguez",
    location: "Los Angeles, CA",
    rating: 5,
    comment: "Los cuadros de aluminio son perfectos para mi oficina. Colores vibrantes y muy modernos.",
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Carlos"
  },
  {
    id: 3,
    name: "Ana Martínez",
    location: "Houston, TX",
    rating: 5,
    comment: "Excelente servicio y calidad. El proceso de pedido fue muy fácil y rápido.",
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Ana"
  }
];

export const faqs = [
  {
    id: 1,
    question: "¿Qué tipo de archivos aceptan?",
    answer: "Aceptamos JPG, PNG, TIFF y PDF de alta resolución. Recomendamos al menos 300 DPI para mejor calidad."
  },
  {
    id: 2,
    question: "¿Cuánto tiempo tarda el envío?",
    answer: "La producción toma 3-5 días hábiles y el envío 2-7 días dependiendo de tu ubicación en USA."
  },
  {
    id: 3,
    question: "¿Ofrecen garantía de satisfacción?",
    answer: "Sí, garantía 100% de satisfacción. Si no estás feliz con tu producto, lo reemplazamos o reembolsamos."
  },
  {
    id: 4,
    question: "¿Los precios incluyen el envío?",
    answer: "El calculador muestra el precio del producto. Los costos de envío se calculan al finalizar la compra."
  },
  {
    id: 5,
    question: "¿Puedo ver una vista previa antes de ordenar?",
    answer: "Sí, al subir tu imagen podrás ver una vista previa de cómo se verá tu producto final."
  },
  {
    id: 6,
    question: "¿Se puede escribir sobre las señales de PVC?",
    answer: "Sí, se puede escribir sobre las señales de PVC con un Sharpie u marcador permanente."
  },
  {
    id: 7,
    question: "¿Dónde se colocan los ojales en las señales de PVC?",
    answer: "En las señales de PVC, los ojales se pueden colocar en las cuatro esquinas o solo en las esquinas superiores."
  },
  {
    id: 8,
    question: "¿Las señales de PVC son para uso interior o exterior?",
    answer: "Las señales de PVC son muy duraderas y resistentes al clima, lo que las hace excelentes para uso interior y exterior."
  },
  {
    id: 9,
    question: "¿Cuál es el grosor de las señales de PVC?",
    answer: "Las señales de PVC tienen 3mm (⅛\") de grosor, proporcionando rigidez adecuada mientras se mantienen ligeras."
  },
  {
    id: 10,
    question: "¿Puedo ordenar señales de PVC más grandes que el tamaño máximo?",
    answer: "Sí, las señales de PVC más grandes se pueden producir a través de pedidos personalizados. Contáctanos para más información."
  },
  {
    id: 11,
    question: "¿Se puede escribir sobre las señales de Coroplast?",
    answer: "Sí, se puede escribir sobre las señales de Coroplast con un Sharpie u marcador permanente."
  },
  {
    id: 12,
    question: "¿Cuántos H-Stakes necesito para una señal de Coroplast?",
    answer: "Un H-Stake es típicamente suficiente para una señal de Coroplast, pero si la señal es más grande que 24\" x 18\" entonces se pueden usar dos H-Stakes para mayor estabilidad."
  },
  {
    id: 13,
    question: "¿Se pueden agregar ojales a las señales de Coroplast?",
    answer: "Sí, los ojales están disponibles para señales de Coroplast en las cuatro esquinas o en las dos esquinas superiores por un pequeño cargo adicional. Los ojales tienen un diámetro exterior de ¾\"."
  },
  {
    id: 14,
    question: "¿Las señales de Coroplast son para uso interior o exterior?",
    answer: "Las señales de Coroplast son excelentes tanto para uso interior como exterior, pero se usan típicamente en exteriores. Son resistentes al agua y tienen tintas curadas UV."
  },
  {
    id: 15,
    question: "¿Qué tamaño de texto necesito para ver la señal de Coroplast a distancia?",
    answer: "Para letras de 3\" la distancia máxima de legibilidad es 100'. Para 6\" es 200'. Para 12\" es 525'. Esta tabla está basada en texto oscuro sobre fondo blanco en condiciones climáticas claras."
  },
  {
    id: 16,
    question: "¿Qué incluyen las Sidewalk Signs (A-Frame)?",
    answer: "Las Sidewalk Signs incluyen el marco de plástico duradero Signicade® y los insertos de Coroplast 4mm impresos a todo color. Todo listo para usar inmediatamente."
  },
  {
    id: 17,
    question: "¿Cuál es la diferencia entre los tamaños de Sidewalk Signs?",
    answer: "Ofrecemos 3 tamaños: Quik Sign (24\"x18\" - compacto), MDX (18\"x24\" - mediano) y Deluxe (24\"x36\" - grande). El tamaño adecuado depende del espacio disponible y la visibilidad deseada."
  },
  {
    id: 18,
    question: "¿Los insertos de las Sidewalk Signs son intercambiables?",
    answer: "Sí, los insertos de Coroplast 4mm son completamente intercambiables. Puedes ordenar insertos adicionales para cambiar tu mensaje según la temporada o promoción."
  },
  {
    id: 19,
    question: "¿Las Sidewalk Signs resisten el clima exterior?",
    answer: "Sí, están diseñadas para uso exterior en todo clima. Los marcos son de plástico duradero y los insertos de Coroplast tienen tintas curadas UV resistentes al agua y al sol."
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/77eth7v7_mounted-canvas.webp",
    category: "canvas",
    title: "Canvas Familiar - Recuerdos que perduran"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/s3abmrkv_canvas_b_w.webp",
    category: "canvas",
    title: "Canvas Personalizado - Niña con mascota"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/09ii342f_canvas-zoomed.webp",
    category: "canvas",
    title: "Detalle de Calidad Canvas"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1730991539023-2bcf7403f1bd",
    category: "canvas",
    title: "Canvas en Sala Moderna"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/862rujqs_aluminum-dye-sub.webp",
    category: "aluminum",
    title: "Paneles Informativos - Aluminio Sublimado"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/a8rvfoli_aluminum-dye-sub-2r.webp",
    category: "aluminum",
    title: "Señalética Corporativa - Alta Definición"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/o93i6p37_clear-acrylic-2r.webp",
    category: "acrylic",
    title: "Señal Acrílica - Lotus Beauty Spa"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/oz3jom51_clear-acrylic-signs.webp",
    category: "acrylic",
    title: "Señal Médica - Cardiology Department"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/0ps05ee5_frosted-acrylic-sign-1.jpg",
    category: "acrylic",
    title: "Señalética Personalizada - Design Sign"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/4kljeogd_TT-WALL-SIGN-2-OUTPUT.png",
    category: "acrylic",
    title: "Señal Industrial - Pumping Stations"
  },
  {
    id: 11,
    url: "https://images.unsplash.com/photo-1513519245088-0e12902e5a38",
    category: "framed",
    title: "Galería de Fotos"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/oeh1swx6_artist-canvas-banners.webp",
    category: "banner",
    title: "Banner Canvas - Contemporary African Art"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/ak0dsvc8_artist-canvas-banners-1r.webp",
    category: "banner",
    title: "Banner Canvas - Architects to Watch"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_photo-frames-store-3/artifacts/lwjrlxyd_artist-canvas-banners-2r.webp",
    category: "banner",
    title: "Banner Canvas - Spring Sale"
  },
  {
    id: 16,
    url: "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/zis1nehp_pvc-signs.webp",
    category: "pvc",
    title: "PVC Sign - Directional Signage"
  },
  {
    id: 17,
    url: "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/ozw7zldu_zoo-pvc-signs-b_w.webp",
    category: "pvc",
    title: "PVC Sign - Coffee Shop"
  },
  {
    id: 18,
    url: "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/zjhs9dt3_foam-core-signs.webp",
    category: "foam-core",
    title: "Foam Core Sign - Wedding Display"
  },
  {
    id: 19,
    url: "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/vax176vy_71PgUlYAZbL._AC_SX679_.jpg",
    category: "foam-core",
    title: "Foam Core Boards - Material"
  },
  {
    id: 20,
    url: "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/ahkwrac9_coroplast-signs.webp",
    category: "coroplast",
    title: "Coroplast Sign - Political"
  },
  {
    id: 21,
    url: "https://customer-assets.emergentagent.com/job_26ece126-d7e8-4238-95fa-209b7f0710a0/artifacts/ziih320p_coroplast-b_w.webp",
    category: "coroplast",
    title: "Coroplast Sign - Yard Sign"
  },
  {
    id: 22,
    url: "https://customer-assets.emergentagent.com/job_388b0df2-b5ee-4956-bc68-28d7ba263f07/artifacts/m3y4ron6_PR_1245-01_SideWalkSign.png",
    category: "sidewalk-signs",
    title: "Sidewalk Sign - Organic Juice Promo"
  },
  {
    id: 23,
    url: "https://customer-assets.emergentagent.com/job_388b0df2-b5ee-4956-bc68-28d7ba263f07/artifacts/q05hj8si_sidewalk-signs_1.webp",
    category: "sidewalk-signs",
    title: "Sidewalk Signs - Tres Tamaños Disponibles"
  },
  {
    id: 24,
    url: "https://customer-assets.emergentagent.com/job_24e755e1-70ea-4e28-aba4-b43c9ab71ff4/artifacts/eff3zczq_mesh-banner.webp",
    category: "mesh-banner",
    title: "Mesh Banner - Sports Goods"
  },
  {
    id: 25,
    url: "https://customer-assets.emergentagent.com/job_24e755e1-70ea-4e28-aba4-b43c9ab71ff4/artifacts/njxe8s9u_mesh-banner._b_w.webp",
    category: "mesh-banner",
    title: "Mesh Banner - Baseball Camp"
  }
];
